import { createAction } from '@reduxjs/toolkit';

export const nftUpdateId = createAction('nft/updateId');
export const nftUpdateUID = createAction('nft/updateUid');
export const nftUpdateSID = createAction('nft/updateSid');
export const nftUpdateIsAdded = createAction('nft/updateIsAdded');
export const nftUpdateIsActive = createAction('nft/updateIsActive');

export const nftStore = createAction('nft/store');
export const nftClear = createAction('nft/clear');

export const nftUpdateRequest = createAction('nft/updateRequest');
export const nftUpdateError = createAction('nft/updateError');
export const nftUpdateStore = createAction('nft/updateStore');

export const nftUpdateItems = createAction('nft/updateItems');

export const nftUpdateLayout = createAction('nft/updateLayout');
export const nftUpdateView = createAction('nft/updateView');

export const nftUpdateHeadingTitle = createAction('nft/updateHeadingTitle');
export const nftUpdateHeadingDescription = createAction('nft/updateHeadingDescription');
export const nftUpdateHeadingTextAlign = createAction('nft/updateHeadingTextAlign');
export const nftUpdateHeadingImage = createAction('nft/updateHeadingImage');
export const nftUpdateHeadingDivider = createAction('nft/updateHeadingDivider');

export const nftUpdateSectionIsBackground = createAction('nft/updateSectionIsBackground');
export const nftUpdateSectionTextColor = createAction('nft/updateSectionTextColor');
export const nftUpdateSectionBackgroundColor = createAction('nft/updateSectionBackgroundColor');
export const nftUpdateSectionOpacity = createAction('nft/updateSectionOpacity');
export const nftUpdateSectionIsFullWidth = createAction('nft/updateSectionIsFullWidth');
export const nftUpdateSectionShadow = createAction('nft/updateSectionShadow');
export const nftUpdateSectionShadowColor = createAction('nft/updateSectionShadowColor');
export const nftUpdateSectionPadding = createAction('nft/updateSectionPadding');
export const nftUpdateSectionMargin = createAction('nft/updateSectionMargin');
export const nftUpdateSectionBackgroundType = createAction('nft/updateSectionBackgroundType');
export const nftUpdateSectionBackgroundImage = createAction('nft/updateSectionBackgroundImage');
export const nftUpdateSectionGradientColor1 = createAction('nft/updateSectionGradientColor1');
export const nftUpdateSectionGradientColor2 = createAction('nft/updateSectionGradientColor2');
export const nftUpdateSectionGradientDirection = createAction('nft/updateSectionGradientDirection');
export const nftUpdateSectionGradientOffset = createAction('nft/updateSectionGradientOffset');
export const nftUpdateSectionBorder = createAction('nft/updateSectionBorder');
export const nftUpdateSectionBorderColor = createAction('nft/updateSectionBorderColor');
export const nftUpdateSectionShadowBorderColor = createAction('nft/updateSectionShadowBorderColor');
export const nftUpdateSectionShape = createAction('nft/updateSectionShape');
